export default __webpack_public_path__ + "static/media/action-icon.7c508ed4.svg";